import { render, staticRenderFns } from "./IdleWidget.vue?vue&type=template&id=2bea487b&scoped=true&"
import script from "./IdleWidget.vue?vue&type=script&lang=js&"
export * from "./IdleWidget.vue?vue&type=script&lang=js&"
import style0 from "./IdleWidget.vue?vue&type=style&index=0&id=2bea487b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea487b",
  null
  
)

export default component.exports